import React, { useState, Fragment, useEffect } from "react";
import { Table, Button } from "reactstrap";
import ModalGroup from "../../Modals/ModalGroup";
import { LoadingMessage } from "../../Controls";
import LaddaButton, { ZOOM_OUT, XS } from "react-ladda";
import { Mode, WizzMode } from "../../types";
import { useEntities } from "../../Wizzard";

const Groups = ({
  mode,
  assetId,
  assetGroups,
  services,
  wizzToggle,
  wizzOnChange,
}) => {
  const [readonly, setReadonly] = useState(mode == WizzMode.View);
  const [modalGroup, setModalGroup] = useState({ open: false });
  const [deleting, setDeleting] = useEntities({});

  useEffect(() => {
    if (mode) {
      setReadonly(mode == WizzMode.View);
    }
  }, [mode]);

  const toggle = (props) => {
    setModalGroup({ open: !modalGroup.open, ...props });
  };

  // handle grid actions
  const handleAction = (action, group, value) => {
    if (action == Mode.Insert) {
      toggle({
        assetId,
        action,
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Update) {
      toggle({
        assetId,
        action,
        group: assetGroups.find(
          (c) => c.AssetGroupId == group && c.AssetGroupValue == value
        ),
        onConfirm: (e) => handleSave(action, e),
      });
    } else if (action == Mode.Delete) {
      wizzToggle("confirm", {
        title: "Delete asset group",
        message: "Are you sure you want to delete asset group?",
        onConfirm: () => handleDelete(group, value),
      });
    }
  };

  // callback after modal confirm
  const handleSave = (action, group) => {
    return services
      .updateGroup({
        assetId,
        action,
        group,
      })
      .then((res) => res.result)
      .then((result) => {
        if (result.Code == 200) {
          wizzOnChange({
            Groups: [group].concat(
              assetGroups.filter(
                (e) =>
                  e.AssetGroupId != group.AssetGroupId ||
                  (e.AssetGroupId == group.AssetGroupId &&
                    e.AssetGroupValue != group.AssetGroupValue)
              )
            ),
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }

        return result.Code;
      });
  };

  // callback after confirm delete
  const handleDelete = (id, value) => {
    setDeleting({ [`${id}-${value}`]: true });
    services
      .updateGroup({
        assetId,
        action: Mode.Delete,
        group: assetGroups.find(
          (e) => e.AssetGroupId == id && e.AssetGroupValue == value
        ),
      })
      .then((res) => res.result)
      .then((result) => {
        setDeleting({ [`${id}-${value}`]: false });
        if (result.Code == 200) {
          assetGroups.splice(
            assetGroups.findIndex(
              (e) => e.AssetGroupId == id && e.AssetGroupValue == value
            ),
            1
          );
          wizzOnChange({
            Groups: assetGroups,
          });
        } else {
          wizzToggle("message", {
            title: "Error",
            message: result.Description,
          });
        }
      });
  };

  return (
    <div>
      {!readonly && (
        <Button
          color="primary"
          className="mb-3"
          onClick={() => handleAction(Mode.Insert)}
        >
          <i className="fa fa-plus mr-1" aria-hidden="true"></i>
          Add asset group
        </Button>
      )}
      <Table>
        <thead>
          <tr>
            <th>Group Name</th>
            <th>Group Value</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {assetGroups ? (
            <Fragment>
              {assetGroups.map((item) => (
                <tr key={`set-${item.AssetGroupId}-${item.AssetGroupValue}`}>
                  <td>{item.AssetGroupName}</td>
                  <td>{item.AssetGroupValue}</td>
                  <td>
                    {!readonly && (
                      <Actions
                        id={item.AssetGroupId}
                        valueId={item.AssetGroupValue}
                        action={handleAction}
                        deleting={
                          !!deleting[
                            `${item.AssetGroupId}-${item.AssetGroupValue}`
                          ]
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
              {assetGroups.length == 0 && <EmptyOrLoading />}
            </Fragment>
          ) : (
            <EmptyOrLoading loading={true} />
          )}
        </tbody>
      </Table>

      <ModalGroup {...modalGroup} toggle={toggle} services={services} />
    </div>
  );
};

const EmptyOrLoading = ({ loading }) => (
  <tr>
    <td colSpan="3">
      {loading ? (
        <LoadingMessage text="Loading groups" />
      ) : (
        <span className="text-center d-block h5 m-3" style={{textAlign: "center"}}>No asset groups</span>
      )}
    </td>
  </tr>
);

const Actions = ({ action, id, valueId, deleting }) => (
  <div className="d-flex justify-content-end">
    <Button
      color="primary"
      size="sm"
      className="mr-2"
      disabled
      onClick={() => action(Mode.Update, id, valueId)}
    >
      <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
    </Button>

    <LaddaButton
      className="btn btn-ladda btn-danger btn-sm"
      loading={deleting}
      onClick={() => action(Mode.Delete, id, valueId)}
      data-style={ZOOM_OUT}
      data-size={XS}
    >
      <i className="fa fa-trash-o" aria-hidden="true"></i>
    </LaddaButton>
  </div>
);

export default Groups;
